/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import GmailAccountEditor from './index';
import TextField from '../TextField';
import { DemoHide } from '../Wrappers';

export function GmailImporter({ model, field, form }) {
	return (
		<div>
			<GmailAccountEditor
				model={model.gmailAccount}
				field={(name) => field(`gmailAccount.${name}`)}
				form={form}
				onSubmit={() => {}}
			/>
			<Card>
				<CardContent>
					<Typography variant="h2">
						Mails to read
					</Typography>
					<TextField
						{...field('mailFrom')}
						label="Sender email address"
						required
						emails
						fullWidth
						margin="normal"
					/>
					<DemoHide cond={!model.isNew}>
						<TextField
							{...field('mailSubjectContains')}
							label="Mail subject must contain"
							fullWidth
							margin="normal"
						/>
					</DemoHide>
				</CardContent>
			</Card>
		</div>
	);
}

GmailImporter.propTypes = {
	model: PropTypes.object.isRequired,
	form: PropTypes.object.isRequired,
	field: PropTypes.func.isRequired,
};

GmailImporter.defaultProps = {
};
